import { userStore } from './store';

type UnauthorizedHandler = () => Promise<void>;
interface AuthFetchOptions {
  retryUnauthorized?: boolean;
}
let unauthorizedHandler: UnauthorizedHandler | null = null;

export const setUnauthorizedHandler = (handler: UnauthorizedHandler | null): void => {
  unauthorizedHandler = handler;
};

export const authFetch = async (
  input: RequestInfo | URL,
  init: RequestInit = {},
  options: AuthFetchOptions = {},
): Promise<Response> => {
  const headers = new Headers(init.headers);
  if (userStore.token) headers.set('Authorization', `Bearer ${userStore.token}`);

  const response = await fetch(input, { ...init, headers });

  if (response.status === 401 && unauthorizedHandler && options.retryUnauthorized !== false) {
    try {
      await unauthorizedHandler();
      const retryHeaders = new Headers(init.headers);
      if (userStore.token) retryHeaders.set('Authorization', `Bearer ${userStore.token}`);
      return fetch(input, { ...init, headers: retryHeaders });
    } catch {
      return response;
    }
  }

  return response;
};
